export interface JumpNavItem {
  anchorId: string
  anchorLinkText: string
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
}

export const FormatArticleAnchors = (articleContent: object): JumpNavItem[] => {
  const articleAnchors: JumpNavItem[] = []

  if (articleContent) {
    Object.values(articleContent)?.forEach((content: any) => {
      if (content.data?.target?.__typename === "ArticleAnchor") {
        articleAnchors?.push({
          anchorId: content.data?.target?.anchorId,
          anchorLinkText: content.data?.target?.anchorLinkText,
        })
      }
    })
  }
  return articleAnchors
}

function extractTextFromNode(node: any): string {
  if (node.nodeType === "text") return node.value || ""
  if (Array.isArray(node.content)) {
    return node.content.map(extractTextFromNode).join("")
  }
  return ""
}

export const FormatH2Anchors = (articleContent: object): JumpNavItem[] => {
  const headings: JumpNavItem[] = []

  if (articleContent) {
    Object.values(articleContent)?.forEach((node: any) => {
      if (node.nodeType === "heading-2") {
        const text = extractTextFromNode(node).trim()
        if (text) {
          headings.push({
            anchorId: slugify(text),
            anchorLinkText: text,
          })
        }
      }
    })
  }
  return headings
}
